import type { ShareAdapter } from '../types';
export const webShare: ShareAdapter = {
  buildShareUrl(serialized) {
    return `${location.origin}${location.pathname}#s=${serialized}`;
  },
  async share(serialized, opts) {
    const url = this.buildShareUrl(serialized);
    if (navigator.share) {
      await navigator.share({ url, title: opts?.name ?? 'My Ship' });
    } else {
      await navigator.clipboard.writeText(url);
    }
  },
};
